"use strict";

// This gets overridden by rollup
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var exportWordlist = false;
import { id } from "@ethersproject/hash";
import { defineReadOnly } from "@ethersproject/properties";
import { Logger } from "@ethersproject/logger";
import { version } from "./_version";
export var logger = new Logger(version);
export var Wordlist = /*#__PURE__*/function () {
  function Wordlist(locale) {
    _classCallCheck(this, Wordlist);
    logger.checkAbstract(this instanceof Wordlist ? this.constructor : void 0, Wordlist);
    defineReadOnly(this, "locale", locale);
  }
  // Subclasses may override this
  return _createClass(Wordlist, [{
    key: "split",
    value: function split(mnemonic) {
      return mnemonic.toLowerCase().split(/ +/g);
    }
    // Subclasses may override this
  }, {
    key: "join",
    value: function join(words) {
      return words.join(" ");
    }
  }], [{
    key: "check",
    value: function check(wordlist) {
      var words = [];
      for (var i = 0; i < 2048; i++) {
        var word = wordlist.getWord(i);
        /* istanbul ignore if */
        if (i !== wordlist.getWordIndex(word)) {
          return "0x";
        }
        words.push(word);
      }
      return id(words.join("\n") + "\n");
    }
  }, {
    key: "register",
    value: function register(lang, name) {
      if (!name) {
        name = lang.locale;
      }
      /* istanbul ignore if */
      if (exportWordlist) {
        try {
          var anyGlobal = window;
          if (anyGlobal._ethers && anyGlobal._ethers.wordlists) {
            if (!anyGlobal._ethers.wordlists[name]) {
              defineReadOnly(anyGlobal._ethers.wordlists, name, lang);
            }
          }
        } catch (error) {}
      }
    }
  }]);
}();